import { CHANGE_LOCATION } from "./constants";
import { history } from "redux/configureStore";

export function changeLocation(location) {
  location ? history.push(location) : history.goBack();
  return dispatch => dispatch({ type: CHANGE_LOCATION, payload: location });
}
